

function Logout(props) {
    window.localStorage.clear()
    window.location.replace('/')
}
export default Logout;